export const MAX_LENGTH_PASSWORD = 100;
export const MIN_LENGTH_PASSWORD = 6;
export const FORMAT_DATE = 'YY/MM/DD';
export const FORMAT_DATE_YYYY_MM_DD = 'YY/MM/DD';
export const FORMAT_DATE_YYYYMMDD = 'YYMMDD';
export const FORMAT_DATE_YYYY_MM_DD_USER_MAST = 'YYYY/MM/DD';

export const FORMAT_DATE_TIME_USER_MAST = 'YYYY/MM/DD HH:mm:ss';
export const FORMAT_DATE_YYYYMMDD_USER_MAST = 'YYYYMMDD';
export const FORMAT_TIME = 'HH:mm';
export const FORMAT_DATE_TIME = 'YY/MM/DD HH:mm:ss';
export const MAX_LENGTH_INPUT = 254;
export const MAX_LENTH_USER_ID = 50;
export const MAX_LENGTH_ACCOUNT_ID = 11;
export const REGEX_PSWD_USER_MAST = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
export const REGEX_DATE_USER_MAST = /^\d{4}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/;
export const REGEX_PASSWORD = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{1,100}$/;
export const REGEX_INT_DECIMAL = /^[0-9]{1,7}(?:[.][0-9]{0,3})?$/;
export const REGEX_INT_DECIMAL_2 = /^[0-9]{1,11}(?:[.][0-9]{0,4})?$/;
export const REGEX_NOT_INT_DECIMAL = /[^\d.]/g;
export const REGEX_INT = /^[\d]{1,10}$/;
export const REGEX_INT_AND_DASH = /^[\d-]{1,30}$/;
export const REGEX_ALPHABET_NUMBER = /^[a-zA-Z0-9 _.-]*$/;
export const REGEX_ALPHABET_NUMBER_1 = /^[a-zA-Z0-9]*$/;
export const REGEX_ALPHABET_NUMBER_2 = /^[a-zA-Z0-9!"#$&()*+-./:;<=>?@\\[\]^_`{|}~,'\s]*$/;
export const REGEX_SYMBOL_ONLY = /[^!"#$&()*+,\-./:;<=>?@[\]^_`{|}~\s]/;
export const REGEX_DETE_FORMAT = /(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])/;

export const USER_MANUAL = '簡易マニュアル.pdf';

export const PAGE_SIZE_DEFAULT = 20;
export const PAGE_SIZE_OPTIONS = ['20', '30', '50', '100', '200'];
export const PAGE_SIZE_BL_INFORMATION_OPTIONS = ['20', '30', '50', '100', '200'];
export const PAGE_SIZE_OUTPUT_SEARCH = ['20', '30', '50', '100', '200'];
export const PAGE_SIZE_OPTIONS_ACCOUNT_SEARCH = ['20', '30', '50', '100', '200'];

export const ALL_MENTION_USER_ID = 'all';

export const TIME_LOCALE_LIST = [
  {
    value: '2',
    label: 'Japan',
  },
];

export const SCREEN_ID_LIST_ITEM = [
  {
    value: '040101',
    label: '040101: Loading Data Search',
  },
  {
    value: '340101',
    label: '340101: Loading Data Search (Export)',
  },
];

export enum LangType {
  JAPAN = 'jp',
  ENGLISH = 'en',
  CHINA = 'zh',
}

export enum TransTypeString {
  OCEAN = '1',
  AIR = '2',
}

export enum YesNoType {
  YES = '1',
  NO = '0',
}

export enum YesNoTypeNumber {
  YES = 1,
  NO = 0,
}

export enum TransType {
  OCEAN = 1,
  AIR = 2,
}

export enum ModalType {
  ALL = '0',
  CONSIGNEE = '1',
  SHIPPER = '2',
  AIT = '3',
  END_CD = '4',
}
export enum ButtonActionBl {
  DELETE = 'DELETE',
  ADD = 'ADD',
  COPY = 'COPY',
  UPDATE = 'UPDATE',
}
export enum MenuDisplayAction {
  REGISTER = 'register',
  UPDATE = 'update',
  COPY = 'copy',
  VIEW = 'view',
  DELETE = 'delete',
}
export enum ButtonType {
  CONTAINER = '貨物情報',
  PRE_ALERT = '詳細情報',
  PRE_ALERT_CHAT = '詳細情報(チャット)',
  SHIPPING = '動静情報',
  AN = 'A / N',
  PORTCAST = 'PortCast',
  CHAT = 'チャット',
  CUST_CLEAR_REQ_INFO = '通関依頼詳細',
  CUST_CALENDAR = 'カレンダー',
  NOTICE_URI = '通知内容',
  FILE_UPLOAD = 'ファイルアップロード',
}

export enum UserMastAction {
  DELETE = 'delete',
  ADD = 'add',
  UPDATE = 'update',
}

export const TYPE_COMMON = {
  STATUS: 'UPDATE_STATUS',
  TRANS_TYPE: 'TRANS_TYPE',
  DISCHARGE: 'VANNING_TYPE',
  DISCHARGE_EXPORT: 'VANNING_TYPE_EXPORT',
  TERM: 'PC_TYPE',
  BL_TYPE: 'BL_TYPE',
  ENTITY_TYPE: 'ENTITY_TYPE',
  CONT_TYPE: 'CONT_TYPE',
  SALE_DEPT: 'SALES_DEPT',
  SEARCH_BY_INT: 'SEARCH_BY_INT',
  SEARCH_BY_INT_EXPORT: 'SEARCH_BY_INT_EXPORT',
  SQL_TYPE: 'SQL_TYPE',
  OFFICE_CD: 'OFFICE_CD',
  AUTHORITY_CD: 'AUTHORITY_CD',
  LOGIN_STATUS: 'LOGIN_STATUS',
  SEARCH_USER_TYPE: 'SEARCH_USER_TYPE',
  SALES_OFFICE_CD: 'SALES_OFFICE_CD',
  SALES_DEPT: 'SALES_DEPT',
  SALES_PERSON_CD: 'SALES_PERSON_CD',
  BL_REF_TYPE: 'BL_REF_TYPE',
  LANG_TYPE: 'LANG_TYPE',
  DATE_FORMAT_IN: 'DATE_FORMAT_IN',
  NUM_FORMAT: 'NUM_FORMAT',
  DATE_FORMAT_DISP: 'DATE_FORMAT_DISP',
  PORT_TYPE: 'PORT_TYPE',
  COUNTRY_CD: 'COUNTRY_CD',
  REGION_CD: 'REGION_CD',
  SQL_CONDITION: 'SQL_CONDITION',
  STATUS_MODE: 'STATUS_MODE',
  IN_OUT_FLG: 'IN_OUT_FLG',
  CUST_CLEAR_REQ_STATUS: 'CUST_CLEAR_REQ_STATUS',
  DL_FLG: 'DL_FLG',
  SHIPPING_FORM: 'SHIPPING_FORM',
  SHIPPING_FORM_EXPORT: 'SHIPPING_FORM_EXPORT',
  VEHICLE_TYPE: 'VEHICLE_TYPE',
  VEHICLE_TYPE_EXPORT: 'VEHICLE_TYPE_EXPORT',
  DAY_OF_WEEK: 'DAY_OF_WEEK',
  PRE_TARIFF: 'PRE_TARIFF',
  PRE_TARIFF_EXPORT: 'PRE_TARIFF_EXPORT',
  NOTICE_TYPE: 'NOTICE_TYPE',
  READ_TYPE: 'READ_TYPE',
  TRADE_TYPE: 'TRADE_TYPE',
  NOTICE_ITEM_HBL_BOOKING: 'NOTICE_ITEM_HBL_BOOKING',
  NOTICE_ITEM_HBL_VESSELINFO: 'NOTICE_ITEM_HBL_VESSELINFO',
  NOTICE_ITEM_HBL_VESSELMOVE: 'NOTICE_ITEM_HBL_VESSELMOVE',
  NOTICE_ITEM_CUST: 'NOTICE_ITEM_CUST',
  NOTICE_ITEM_CUST_EXP: 'NOTICE_ITEM_CUST_EXP',
  CUST_CLEAR_REQ_FORWARDER: 'CUST_CLEAR_REQ_FORWARDER',
  CHARGE_CD_EXPORT: 'CHARGE_CD_EXPORT',
  BL_TYPE_EXPORT: 'BL_TYPE_EXPORT',
  CUST_CLEAR_REQ_STATUS_EXPORT: 'CUST_CLEAR_REQ_STATUS_EXPORT',
  CUST_UPLOAD_FILE_MAX_SIZE: 'CUST_UPLOAD_FILE_MAX_SIZE',
  DELIVERY_FLG: 'DELIVERY_FLG',
};

export const STATUS_HTTPS = {
  BAD_REQUEST: 400,
  UNAUTHENTICATED: 401,
  GREATER_RANGE_SUCCESS: 200,
  SMALLER_RANGE_SUCCESS: 300,
  FORBIDDEN: 403,
};

export const TYPE_INPUT = {
  TEXT: 'TEXT',
  RADIO: 'RADIO',
  TEXTAREA: 'TEXTAREA',
  PASSWORD: 'PASSWORD',
  SELECT: 'SELECT',
  CHECKBOX: 'CHECKBOX',
  NUMBER: 'NUMBER',
  SEARCH: 'SEARCH',
  SELECT_INFINITY_SCROLL: 'SELECT_INFINITY_SCROLL',
  SWITCH: 'SWITCH',
  DATE: 'DATE',
  DATE_GROUP: 'DATE_GROUP',
};

export const TYPE_OF_ANT_DESIGN = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  IMG_DONE: 'done',
};

export enum MessageType {
  CODE = 1,
  STRING = 2,
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum AccountAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  ACCOUNT_ID_DEFAULT = 'account',
}

export enum AccountValue {
  IS_DOWNLOAD_EXCEL = '1',
  ENT_TYPE_DEFAULT = '1',
}

export enum AccountType {
  ENT_TYPE = 'ENT_TYPE',
}

export enum GeneralAction {
  REGISTER = 'register',
  UPDATE = 'update',
  HANY_CD_DEFAULT = 'hany',
}

export enum GeneralValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum AccountGrAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  USER_GRP_CD_DEFAULT = 'uGrp',
}

export enum AccountGrValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum PortAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  PORT_CLS_DEFAULT = 'port',
  PORT_CD_DEFAULT = 'port',
}

export enum PortValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum SearchPatternAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  SQL_ID_DEFAULT = 'sql',
}

export enum DocumentType {
  HBL = '1',
  AN = '2',
  INVOICE = '3',
  ETC1 = '4',
  ETC2 = '5',
  ETC3 = '6',
}

export enum HblStatusValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum StatusAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  STATUS_MODE_DEFAULT = 'status',
  STATUS_ID_DEFAULT = 'status',
}

export enum StatusValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum MenuAuthorityAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  MENU_AUTHORITY_DEFAULT = 'menu',
}

export enum MenuAuthorityValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum AitGrAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  GR_CD_DEFAULT = 'grp',
}

export enum AitGrValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum CustClearReqStatus {
  DRAFT = '0',
  UNREGISTERED = '1',
  CUST_DOC_REGISTERED = '2',
  IMPORT_PERMIT = '3',
  COMPLETION = '4',
  DELIVERY_COMPLETED = '5',
}

export enum PicKbn {
  CNEE = '0',
  PIC = '1',
}

export enum CustClearReqDocType {
  CUST_CLEAR = '0',
  IMPORT_PERMIT = '1',
  INVOICE = '2',
  TOTAL_INVOICE = '3',
  RELATED = '4',
  OUTSIDE = '5',
  INVENTORY_LIST = '6', // 輸出で使用
  SI_UPLOAD = '7', // 輸出で使用
}

export enum CustClearReqAction {
  DETAIL = 'detail',
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  CUST_CLEAR_REQ_NO_DEFAULT = 'custClearReqNo',
  PRE_SCREEN_DEFAULT = 'default',
  PRE_SCREEN_MENU = 'menu',
  PRE_SCREEN_CARGO_TRACE_SEARCH = 'cargoTraceSearch',
  PRE_SCREEN_CALENDAR = 'calendar',
  PRE_SCREEN_NOTICE = 'notice',
  HBL_NO_DEFAULT = 'hblNo',
}

export enum DeliveryDestAction {
  REGISTER = 'register',
  UPDATE = 'update',
  DELETE = 'delete',
  DELIVERY_DEST_CD_DEFAULT = 'deliveryDestCd',
}

export enum DeliveryDestValue {
  IS_DOWNLOAD_EXCEL = '1',
}

export enum AitGrKbn {
  SALES_GR = '0',
  CUST_CLEAR_GR = '1',
  OCEAN_GR = '2',
  CUST_CNEE_GR = '3',
  SHIPPER_GR = '4',
  CUST_CLEAR_GR_EXPORT = '5',
  CUST_CNEE_GR_EXPORT = '6',
  LODING_POL_GR = '99',
}

export enum ChatroomKbn {
  CARGO_TRACE_CLIENT = '11',
  CARGO_TRACE_IN_HOUSE = '10',
  CCR_CLIENT = '21',
  CCR_IN_HOUSE = '20',
  CARGO_TRACE_CLIENT_EXPORT = '31',
  CARGO_TRACE_IN_HOUSE_EXPORT = '30',
  CCR_CLIENT_EXPORT = '41',
  CCR_IN_HOUSE_EXPORT = '40',
}

export enum KidokuFlg {
  READ = 0,
  UNREAD = 1,
  ALL = 9,
}

export enum ExportFlg {
  Import = '0',
  Export = '1',
}

export enum NoticeType {
  HBL_INSER = '1',
  HBL_BOOKING = '2',
  HBL_DELAY = '3',
  CUST_INSER = '4',
  CUST_UPDATE = '5',
  CHAT = '6',
  CHAT_HBL = '8',
  CHAT_CUST = '9',
  VESSELE_MOVE = '10',
  VESSELE_MOVE_HBL = '11',
  CUST_EXP_INSER = '12',
  CUST_EXP_UPDATE = '13',
  CHAT_CUST_EXP = '14',
}
